/**
 * Contact page – reliable scroll to #kontakt (footer + in-page links).
 */
(() => {
  const HASH = '#kontakt';

  const isContactPage = () => {
    const path = window.location.pathname || '';
    return path.includes('/pages/contact') || path.endsWith('/contact');
  };

  const scrollToKontakt = () => {
    const target = document.getElementById('kontakt');
    if (!target) return;

    const header = document.querySelector('.shopify-section-group-header-group .header-wrapper');
    const offset = header instanceof HTMLElement ? header.offsetHeight + 20 : 96;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    target.focus({ preventScroll: true });
  };

  const handleHash = () => {
    if (window.location.hash !== HASH) return;
    window.requestAnimationFrame(() => {
      window.setTimeout(scrollToKontakt, 50);
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest(`a[href="${HASH}"], a[href$="/contact${HASH}"], a[href$="/pages/contact${HASH}"]`);
    if (!link) return;

    if (isContactPage()) {
      event.preventDefault();
      if (window.location.hash !== HASH) {
        history.pushState(null, '', HASH);
      }
      scrollToKontakt();
    }
  });

  window.addEventListener('hashchange', handleHash);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHash);
  } else {
    handleHash();
  }
})();
